// @ts-ignore
/* eslint-disable */
import request from '../../utils/request';

/** 更新rta链路信息 POST /rta-event/update-trace */
export async function rtaEventUpdateTraceUsingPOST(
  body: API.RtaTraceReq,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultVoid>('/rta-event/update-trace', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}
